import React, { Component } from 'react';
import '../../css/style.css';
import '../Home.css';
import { Row, Col, Button, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { sendJson } from '../../backend/Backend';
import { translate } from "react-i18next";
import {BOOKING_STATUS} from '../../backend/Data';


class PublicEventEditBooking extends Component {

    constructor(props) {
        super(props);
        this.onEventInputChange = this.onEventInputChange.bind(this);
        this.saveEvent = this.saveEvent.bind(this);
        this.cancelEvent = this.cancelEvent.bind(this);

        this.state = {
            booking : {eventId: 'X',
            userId: '',
            fullname: '',
            telNr: '',
            email: '',
            comment: '',
            adultCount: 1,
            childCount: 0}
        };
    }

    componentDidMount() {
        let oldState = this.state;
        let selected = this.props.selected;
        this.setState({
            ...oldState,
            booking: selected
        });
       
    }

    onEventInputChange(obj) {
        const { name: fieldName, value: fieldValue } = obj.target;
        let oldState = this.state;
        let oldBooking = this.state.booking;
        let newBooking = {
            ...oldBooking,
            [fieldName]: fieldValue
        }

        this.setState({
            ...oldState,
            booking: newBooking
        });

    }

    saveEvent() {
        let event = this.state;

        console.log("saving event : " + JSON.stringify(event));

        sendJson('post', 'booking/create', event).then(
            received => {
                console.log("Saved Eventid: " + JSON.stringify(received));

                //if(received.ok){
                this.props.executeBooking();
                //}
            });

    }

    cancelEvent() {
        this.props.executeBooking();
    }

   
    render() {
   
        const { t } = this.props;
        const {  fullname, telNr, email, comment, adultCount, childCount, bookingStatus, remark } = this.state.booking;
        return (
            <div className="ml-5">
                <Row >
                    <Col lg={8} md={8} className="mt-1">
                    <Form.Control value={fullname}
                            name="fullname"
                            onChange={this.onEventInputChange}
                            placeholder={t("OptionalName")}
                            id="inputFullname"
                            maxLength={250}
                        />
                    </Col>
                 </Row>
                 <Row>
                   
                    <Col lg={4} md={4} className="mt-1">
                    <Form.Control value={telNr}
                            name="telNr"
                            onChange={this.onEventInputChange}
                            id="inputTel"
                            placeholder={t("optTel")}
                            maxLength={25}
                        />
                    </Col>

                    <Col lg={4} md={4} className="mt-1">
                    <Form.Control value={email}
                            name="email"
                            onChange={this.onEventInputChange}
                            placeholder={t("email")}
                            id="inputEmail"
                            maxLength={250}
                        />
                    </Col>
                    </Row>
                    <Row>
                    <Col lg={4} md={4} className="mt-1">
                       <Form.Group >
                       <Form.Label htmlFor="inputadultCount">{t("adultCount")}</Form.Label>
                       <Form.Control value={adultCount}
                            type="number"
                            min="1"
                            step="1"
                            name="adultCount"
                            onChange={this.onEventInputChange}
                            placeholder={t("adultCount")}
                            id="inputadultCount"
                            style={{width:"80px"}}
                        />
                        </Form.Group>
                       
                    </Col>

                    <Col lg={4} md={4} className="mt-1">
                    <Form.Group >
                       <Form.Label htmlFor="inputchildrenCount" className="ml-2 mr-2">{t("childCount")}</Form.Label>
                        <Form.Control value={childCount}
                            type="number"
                            min="1"
                            step="1"
                            name="childCount"
                            onChange={this.onEventInputChange}
                            placeholder={t("childCount")}
                            id="inputchildrenCount"
                            style={{width:"80px"}}
                        />
                        </Form.Group>
                    </Col>                    
                    </Row>
                    <Row>
                    <Col lg={8} md={8} className="mt-1">
                    <Form.Group controlId="bookingStatus">
                        <Form.Label>{t("userComment")}</Form.Label>
                        <Form.Control value={comment}
                            as="textarea"
                            name="comment"
                            placeholder={t("KommentarEingeben")}
                            onChange={this.onEventInputChange}
                            readOnly={true}
                            maxLength={250}
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col lg={8} md={8} className="mt-1">
                    <Form.Group controlId="remark">
                        <Form.Label>{t("remark")}</Form.Label>
                        <Form.Control value={remark}
                            as="textarea"
                            name="remark"
                            placeholder={t("remark")}
                            onChange={this.onEventInputChange}
                            maxLength={250}
                        />
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col lg={8} md={8}>
                    <Form.Group controlId="bookingStatus">
                                    <Form.Label>{t("bookingStatus")}</Form.Label>
                                    <Form.Control as="select" name="bookingStatus" value={bookingStatus} onChange={this.onEventInputChange}>
                                        {BOOKING_STATUS.map((r, i) =>
                                            <option selected={bookingStatus === r} key={bookingStatus} value={r}>{t(r)}</option>
                                        )}

                                    </Form.Control>
                                </Form.Group>
                    </Col>
                </Row>
               
                <Row className="mt-1 mb-2">
                 
                
                 <Col lg={1} md={1} xs={3}>
                 <OverlayTrigger
                     key="top"
                     placement="top"
                     overlay={
                     <Tooltip id={`tooltip-top`}>
                          {t("verwerfen")}
                     </Tooltip>
                     }>
                         <Button variant="outline-primary" onClick={ this.props.onBookingRevert}><span className="fa fa-undo"></span></Button>
                     </OverlayTrigger>
                     
                 </Col>
                 <Col lg={1} md={1} xs={3}>
                 <OverlayTrigger
                     key="top"
                     placement="top"
                     overlay={
                     <Tooltip id={`tooltip-top`}>
                          {t("speichern")}
                     </Tooltip>
                     }>
                     <Button variant="outline-primary" onClick={() =>  this.props.onBookingEdit(this.state.booking)}><span className="fa fa-save"></span></Button>
                     </OverlayTrigger>
                 </Col>
                 <Col lg={7} md={7} xs={2}>
                     &nbsp;
                 </Col>
             </Row>
            </div>

        );
    }

}

export default translate("translations")(PublicEventEditBooking);